import { render, staticRenderFns } from "./BuildingSocietyFile.vue?vue&type=template&id=60db769f&scoped=true&"
import script from "./BuildingSocietyFile.vue?vue&type=script&lang=js&"
export * from "./BuildingSocietyFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60db769f",
  null
  
)

export default component.exports